<template>
  <span class="cu-chip"
        :class="'--' + variant">{{ label }}</span>
</template>

<script>
// The status chip of a customer: the label is the API's chipTh, the colour follows the facts
// (tracked = blue, ordered = green, otherwise grey), like the mockup's sbadge pills.
export default {
  name: "CustomerChip",
  props: {
    label: { type: String, default: "" },
    tracked: { type: Boolean, default: false },
    ordered: { type: Boolean, default: false },
  },
  computed: {
    variant() {
      return this.tracked ? "primary" : this.ordered ? "success" : "muted";
    },
  },
};
</script>

<style lang="scss" scoped>
.cu-chip {
  display: inline-block;
  flex: 0 0 auto;
  padding: 0.2rem 0.7rem;
  border-radius: 10rem;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;

  &.--primary {
    background: rgba($brand-blue-mid, 0.12);
    color: $brand-blue-mid;
  }

  &.--success {
    background: rgba(48, 196, 76, 0.15);
    color: #1a6e2e;
  }

  &.--muted {
    background: rgba(158, 158, 158, 0.15);
    color: #6b6b6b;
  }
}

body.--dark .cu-chip {
  &.--primary {
    background: rgba(95, 168, 224, 0.2);
    color: #8cc8f5;
  }

  &.--success {
    background: rgba(48, 196, 76, 0.2);
    color: #8fe3a0;
  }

  &.--muted {
    background: rgba(200, 200, 200, 0.18);
    color: #c4c4c4;
  }
}
</style>

